export const GENDER_STORE = 'GENDER_STORE';
export const GENDER_UPDATE = 'GENDER_UPDATE';
export const GENDER_DESTROY = 'GENDER_DESTROY';
